module.exports = __webpack_public_path__ + "static/img/icon_hkd.4d80f687.png";